import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { GenericDropdownModule } from 'app/shared/generic-dropdown/generic-dropdown.module';
import { ContactDropdownComponent } from './contact-dropdown.component';

@NgModule({
	declarations: [ContactDropdownComponent],
	exports: [ContactDropdownComponent],
	imports: [CommonModule, GenericDropdownModule, FormsModule]
})
export class ContactDropdownModule {}
